import React, { useEffect, useRef } from "react";

export default function AdSlot({
  slot,
  format = "auto",
  fullWidthResponsive = true,
  style,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const pushAd = () => {
      try {
        // évite doublons
        if (el.getAttribute("data-ad-status")) return;
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch {}
    };

    // lazy: n’injecte que quand visible
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && pushAd()),
      { rootMargin: "200px" }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <ins
      ref={ref}
      className="adsbygoogle"
      style={{ display: "block", ...style }}
      data-ad-client="ca-pub-4717440096189113"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
    />
  );
}
